import { AppState } from './app.model';

const appDefault: AppState = {
  contextId: null,
  taskId: null,
  token: null,
};

export default appDefault;
